import { QInput, QIcon, QDialog } from "quasar";
import { defineComponent, defineAsyncComponent, ref, computed, watch, onBeforeMount, createElementBlock, openBlock, createVNode, mergeProps, withCtx, createBlock } from "vue";
import { useI18n } from "vue-i18n";
import { registerEntityEndpoint, isDocumentEditable } from "@editor/ui-utils";
const de = {
  jobs: {
    jobId: "Team-ID",
    job: "Team",
    displayName: "Angezeigter Team-Name",
    lastChange: "Letzte Änderung",
    lastChangeBy: "Letzte Änderung von",
    createJob: "erstelle einen Team",
    editJob: "Edit Team",
    deleteJob: "Lösche Team",
    basics: "Basics",
    backButton: "Zurück",
    settingsLabel: "Einstellugen",
    settings: "Team Erstellen",
    config: "Konfiguration",
    messageNotSelf: "Der übergeordnete Team kann nicht in diesem Team sein",
    messageMandatoryInfo: "Du kannst die Team noch nicht speichern, da benötigte Informationen fehlen",
    messageMandatoryInfoConfig: "Du kannst den Team noch nicht speichern, da benötigte Informationen in der Team config fehlen",
    messageDeleteJob: "Bist du dir sicher, dass du den Team löschen möchtest?",
    messageDeleteJobTitle: "Team löschen",
    messageCreated: "Team erstellt",
    messageUpdated: "Team aktualisiert",
    messageDeleted: "Team löschen",
    defaultConfig: "Standard Team config nutzen",
    errorMandatoryFields: "Entschuldigung, du kannst den Team nicht speichern, weil nicht alle Pflichtfelder ausgefüllt sind",
    errorJobExist: "Team-ID existiert bereits",
    errorJobExistNotification: "Leider können Sie diesen Team nicht speichern, da die Team-ID bereits vorhanden ist (Duplikat).",
    errorJobFailedLoad: "Laden fehlgeschlagen {id}"
  },
  jobList: {
    all: "Alle",
    title: "Teams",
    newButton: "Neues Team",
    search: "Nach Team oder Anzeigename des Teams suchen",
    brand: "Marke",
    loading: "Lade Teams",
    headerTitle: "Titel",
    edit: "Bearbeiten",
    view: "Anzeigen"
  }
};
const en = {
  jobs: {
    jobId: "Team ID",
    job: "Team",
    displayName: "Display name",
    lastChange: "Last Change",
    lastChangeBy: "Last Change by",
    createJob: "create Team",
    editJob: "edit Team",
    deleteJob: "Delete Team",
    basics: "Basics",
    backButton: "Back",
    settings: "Create Team",
    settingsLabel: "Settings",
    config: "Configuration",
    messageNotSelf: "The parent Team can't be this channel",
    messageMandatoryInfo: "You can't save this Team because it is missing mandatory information",
    messageMandatoryInfoConfig: "You can't save this team because the Team configuration is missing mandatory information",
    messageDeleteJobTitle: "Delete Team",
    messageDeleteJob: "Are you sure you want to delete this Team?",
    messageCreated: "Team created",
    messageUpdated: "Team updated",
    messageDeleted: "Team deleted",
    defaultConfig: "Use standard Team configuration",
    errorMandatoryFields: "Sorry, you can't save this Team because it's missing mandatory information",
    errorJobExist: "Team ID already exists",
    errorJobExistNotification: "Sorry, you can't save this Team because Team ID already exists (duplicate)",
    errorJobFailedLoad: "Failed to load {id}"
  },
  jobList: {
    all: "All",
    title: "Team",
    newButton: "New Team",
    search: "Search by team or display name",
    brand: "Brand",
    loading: "Loading Teams",
    headerTitle: "Title",
    edit: "Edit",
    view: "Show"
  }
};
const messages = { en, de };
const JobGroupModelName = "Jobs";
const JobService = registerEntityEndpoint(JobGroupModelName);
const { listEntities, getEntity, postEntity, putEntity, deleteEntity } = JobService;
const getJobs = async (search = void 0, options) => {
  return listEntities({ params: { ...options, search } });
};
const getJob = async (id) => {
  return getEntity(id);
};
const loadMainJobs = async (parameters) => {
  return listEntities({
    params: {
      ...parameters,
      isRootJob: true
    }
  });
};
const deleteJob = async (id) => {
  return deleteEntity(id);
};
const postJob = async (job) => await postEntity(job);
const putJob = async (job) => await putEntity(job._id, job);
const getDefaultStateJob = () => ({
  _id: "",
  createDate: /* @__PURE__ */ new Date(),
  changeDate: /* @__PURE__ */ new Date(),
  displayName: "",
  job: "",
  jobId: "",
  isDeleted: false
});
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "job-list.selector",
  props: {
    modelValue: { type: String, required: false, default: "" },
    label: { type: String, required: false, default: void 0 },
    disabled: { type: Boolean, required: false, default: false },
    required: { type: Boolean, required: false, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const JobList = defineAsyncComponent(() => import("./job-list-BdsYTBmV.js"));
    const { t } = useI18n();
    const props = __props;
    const emit = __emit;
    const dialogVisible = ref(false);
    const jobData = ref();
    const jobSelected = (job) => {
      jobData.value = job || { displayName: "" };
      emit("update:modelValue", job == null ? void 0 : job._id);
      dialogVisible.value = false;
    };
    const tLabel = computed(() => !props.label ? t("components.jobSelectorLabel") : props.label);
    const clearJobData = () => {
      jobData.value = { displayName: "", _id: void 0 };
      emit("update:modelValue", jobData.value._id);
    };
    watch(
      () => props.modelValue,
      async () => {
        if (props.modelValue) {
          jobData.value = await getJob(props.modelValue);
        } else {
          clearJobData();
        }
      },
      { deep: true }
    );
    onBeforeMount(async () => {
      jobData.value = await getJob(props.modelValue);
    });
    const __returned__ = { JobList, t, props, emit, dialogVisible, jobData, jobSelected, tLabel, clearJobData, get QDialog() {
      return QDialog;
    }, get QIcon() {
      return QIcon;
    }, get QInput() {
      return QInput;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createVNode($setup["QInput"], mergeProps({
      modelValue: $setup.jobData.displayName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.jobData.displayName = $event),
      "data-qa-job-input-field": "",
      class: $props.required && "required",
      disabled: $props.disabled,
      label: $setup.tLabel,
      "background-color": "white",
      clearable: "",
      outlined: "",
      dense: "",
      readonly: ""
    }, _ctx.$attrs, {
      onClick: _cache[1] || (_cache[1] = ($event) => $setup.dialogVisible = true),
      "onClick:clear": _cache[2] || (_cache[2] = ($event) => $setup.jobSelected(void 0)),
      "onClick:append": _cache[3] || (_cache[3] = ($event) => $setup.dialogVisible = true)
    }), {
      append: withCtx(() => [
        !$setup.jobData.displayName ? (openBlock(), createBlock($setup["QIcon"], {
          key: 0,
          name: "external-link"
        })) : (openBlock(), createBlock($setup["QIcon"], {
          key: 1,
          name: "clear",
          onClick: $setup.clearJobData
        }))
      ]),
      _: 1
      /* STABLE */
    }, 16, ["modelValue", "class", "disabled", "label"]),
    createVNode($setup["QDialog"], {
      modelValue: $setup.dialogVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => $setup.dialogVisible = $event),
      "data-qa-job-modal": "",
      "full-width": "",
      "full-height": "",
      onHide: _cache[7] || (_cache[7] = ($event) => $setup.dialogVisible = false)
    }, {
      default: withCtx(() => [
        createVNode($setup["JobList"], {
          dialog: true,
          "filter-id": $setup.jobData._id,
          "is-job-query": true,
          "show-new-button": false,
          onClose: _cache[4] || (_cache[4] = ($event) => $setup.dialogVisible = false),
          "onClick:job": $setup.jobSelected,
          "onBack:modal": _cache[5] || (_cache[5] = ($event) => $setup.dialogVisible = false)
        }, null, 8, ["filter-id"])
      ]),
      _: 1
      /* STABLE */
    }, 8, ["modelValue"])
  ]);
}
const JobListSelector = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-d52b5f9b"], ["__file", "/builds/CT/content-technology-framework/modules/job/editor-ui/src/selectors/job-list.selector.vue"]]);
const routes = [
  {
    path: "/job-groups",
    children: [
      {
        path: "",
        name: "job_list",
        component: () => import("./job-list-BdsYTBmV.js"),
        props: (route) => ({ query: route.query.search, brand: route.query.brand }),
        meta: { requiredRight: "navigate_list_job" }
      },
      {
        path: "new",
        name: "job_new",
        component: () => import("./job-edit-DDWpV-gd.js"),
        meta: { requiredRight: "navigate_job" }
      },
      {
        path: ":id",
        name: "job_detail",
        component: () => import("./job-edit-DDWpV-gd.js"),
        props: (route) => ({ id: route.params.id, backRoute: "/job-groups", readOnly: !isDocumentEditable("job") }),
        meta: { requiredRight: "navigate_job" }
      }
    ]
  }
];
const jobModule = {
  messages,
  routes
};
export {
  JobService as J,
  _export_sfc as _,
  JobListSelector as a,
  JobGroupModelName as b,
  getJobs as c,
  getJob as d,
  deleteJob as e,
  putJob as f,
  getDefaultStateJob as g,
  jobModule as j,
  loadMainJobs as l,
  postJob as p
};
//# sourceMappingURL=index-BYjPZq-G.js.map
